<div class="access-denied-container bg-[#f2f5f9] h-screen flex items-center justify-center p-4">
  <mat-card class="access-denied-card">
    <mat-card-content>
      <div class="icon-wrapper">
        <mat-icon class="error-icon">block</mat-icon>
      </div>

      <h1 class="title">403 Forbidden</h1>
      <p class="portal-name">{{ portalName }}</p>
      @if (email()) {
        <p class="email">{{ email() }}</p>
      }

      <p class="message">
        You don't have permission to access this page.
        Please contact your administrator if you believe this is an error.
      </p>

      <div class="actions">
        <button mat-raised-button color="primary" type="button" (click)="onLogInAgain()">
          <mat-icon>login</mat-icon>
          Try Again
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
